import {
    addRecentSearch,
    removeRecentSearch
} from 'components/search/helpers/suggestions-api';
import { getPersonalisedBrands, getPersonalisedSearches } from './api';

const setPersonalisedBrandsAction = (items, status) => ({
    type: 'PERSONALISATION/SET_BRANDS',
    items,
    status
});

const setPersonalisedSearchesAction = (items, status) => ({
    type: 'PERSONALISATION/SET_SEARCHES',
    items,
    status
});

const setPersonalisedBrandsStatusAction = status => ({
    type: 'PERSONALISATION/FETCH_BRANDS_STATUS',
    status
});

const setPersonalisedSearchesStatusAction = status => ({
    type: 'PERSONALISATION/FETCH_SEARCHES_STATUS',
    status
});

const recentSearchesIsUpdatedAction = () => ({
    type: 'RECENT_SEARCHES_LAST_UPDATED',
    lastUpdated: Date.now()
});

export const fetchPersonalisedBrandsIfNeeded = () => async (
    dispatch,
    getState
) => {
    const { status } = getState().personalisation.brands;
    if (status !== 'NOT_FETCHED') return;

    dispatch(setPersonalisedBrandsStatusAction('LOADING'));

    const brandsResult = await getPersonalisedBrands();

    const newStatus = brandsResult.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(setPersonalisedBrandsAction(brandsResult, newStatus));
};

export const fetchPersonalisedSearchesIfNeeded = () => async (
    dispatch,
    getState
) => {
    const { status } = getState().personalisation.searches;
    if (status !== 'NOT_FETCHED') return;

    dispatch(setPersonalisedSearchesStatusAction('LOADING'));

    const searchesResult = await getPersonalisedSearches();

    const newStatus = searchesResult.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
    dispatch(setPersonalisedSearchesAction(searchesResult, newStatus));
};

export const addRecentSearchText = text => async dispatch => {
    addRecentSearch(text);
    dispatch(recentSearchesIsUpdatedAction());
};

export const removeRecentSearchText = text => async dispatch => {
    removeRecentSearch(text);
    dispatch(recentSearchesIsUpdatedAction());
};
